import { getSummaryValue, makeExpEstRow, getTitle, makeExpEstHeaders, makeModelTable } from '../utils'
import { findEpiSuiteGroupById } from '@/components/combined-predict/models/epiSuite/epiSuiteColumnGroups'
import { pick } from 'lodash-es'

const modelSummaryMapper = (item, meta) => {
  const selectedValue = getSummaryValue(item?.selectedValue ?? item?.predicted, getTitle(meta))

  return {
    values: [selectedValue],
    tables: [
      {
        headers: makeExpEstHeaders(),
        rows: [makeExpEstRow(item?.experimental, item?.predicted, getTitle(meta))],
      },
    ],
  }
}

const modelDescriptorsMapper = (item) => ({
  tables: [makeModelTable(pick(item?.predicted?.model, ['waterSolubility', 'factors']))],
})

const waterNt = (items) => {
  const item = items?.find((item) => item?.property === 'waterSolubilityFromWaterNt')
  const meta = findEpiSuiteGroupById('waterSolubilityFromWaterNt')

  return {
    title: getTitle(meta),
    description: meta?.description,
    helpPage: meta?.helpPage,
    summary: modelSummaryMapper(item, meta),
    modelDescriptors: modelDescriptorsMapper(item),
    modelOutput: item?.predicted?.model?.output,
  }
}

export { waterNt }
